module.exports = __webpack_public_path__ + "static/media/blog_image_4.7a184d72.webp";